import { Divider, Flex, Text, VStack } from '@chakra-ui/react'
import { FormsViewContext, TextDivider } from '@hb/react-web'
import { useContext } from 'react'
import { PostSignOnText } from './PostSignOnText'
import { SignOnConsentFormsStatus } from './SignOnConsentFormsStatus'
import { SignOnQuestionnaireStatus } from './SignOnQuestionnaireStatus'

{
  /* 
  Sign on status is a component that displays the sign on status of the assessment.
  It shows and allows action on the following:
  - If the patient has completed the sign on questionnaire
  - If the patient has completed the required consent forms
  - If the patient has completed the coverage confirmation
  */
}

export const SignOnStatus = () => {
  const {
    signOnData: { signOnStagesComplete },
  } = useContext(FormsViewContext)
  return (
    <Flex pb={2} w="100%" gap={2} flexDir="column">
      <TextDivider text={signOnStagesComplete ? 'Sign-on Complete!' : 'Complete Sign-on Process'} />
      {signOnStagesComplete ? (
        <PostSignOnText />
      ) : (
        <Text px={2} fontWeight={500} fontSize="lg" opacity={0.8}>
          Please complete the following steps to sign on for coverage:
        </Text>
      )}
      <VStack
        w="100%"
        spacing={0}
        divider={<Divider />}
        borderColor="gray.200"
        bg="gray.50"
        _dark={{ bg: 'gray.800', borderColor: 'gray.700' }}
        borderWidth={1}
        borderRadius={4}>
        <SignOnQuestionnaireStatus />
        {/* <ScheduledCallStatus /> */}
        <SignOnConsentFormsStatus />
      </VStack>
    </Flex>
  )
}
